import React from 'react';
import { Helmet } from 'react-helmet-async';
import { CsvAnalysisPanel } from '@/components/user/csv-analysis/CsvAnalysisPanel';

const CsvAnalysisPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>CSV Analysis - Upload & Analyze Trading Data</title>
        <meta name="description" content="Upload your CSV trading files and analyze historical performance with customizable filters and parameters." />
      </Helmet>
      
      <div className="min-h-screen bg-gradient-to-br from-background via-background/95 to-muted/20">
        <div className="container mx-auto px-4 py-8">
          <div className="max-w-7xl mx-auto">
            <div className="mb-8">
              <h1 className="text-3xl font-bold bg-gradient-to-r from-primary to-primary/70 bg-clip-text text-transparent">
                CSV Analysis
              </h1>
              <p className="text-muted-foreground mt-2">
                Upload your trading CSV files, filter by position size, and analyze historical performance with customizable TP/SL parameters.
              </p>
            </div>
            
            <CsvAnalysisPanel />
          </div>
        </div>
      </div>
    </>
  );
};

export default CsvAnalysisPage;